import { LangObject } from "@brg/api/dist/api-core/utils/lang-utils";
import { FC, useCallback, useState, useMemo } from "react";
import { ITeamFilterModel } from "./TeamFilterEditView";
import { GlobalColoring, ProjectEditPageGrid} from "shared/pages/projectEdit/styles";
import { API, Endpoints, Tag } from "@brg/api";
import LongReadBlock from "shared/pages/projectEdit/LongReadBlock";
import { ComputedTeam } from 'shared/helpers/types/computed/ComputedTeam';
import { ICoverContent } from "shared/pages/exploreHseContextsNew/const/coverContent";
import { CustomBgWrapper } from "shared/components/CustomBgWrapper/CustomBgWrapper";
import { PresentationBlock } from "shared/pages/projectEdit/components/PresentatitonBlock/PresentatitonBlock";
import { createPortal } from "react-dom";
import { useHistory } from "react-router-dom";
import { CreateLinkTo } from "shared/constants/linkTo";
import { ThemeProvider, useTheme } from "styled-components";
import { createThemeByColor } from "shared/helpers/coloring";
import { useToasts } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { useToggleBilingual } from "shared/hooks/useToggleBilingual";
import { IAddProjectCoverContent } from "shared/pages/projectEdit/components/PresentatitonBlock/types/AdditionalContentType";

export const SET_BILINGUAL_FLAG = 'SET_BILINGUAL_FLAG';
export const REMOVE_BILINGUAL_FLAG = 'REMOVE_BILINGUAL_FLAG';

export interface ITeamTab {
    path: string;
    name: LangObject[];
    about: LangObject[];
    filter: ITeamFilterModel;
    isMain: boolean;
    gridTitle: LangObject[];
    gridTitleLink: LangObject[];
}

type TeamTabEditPropsT = {
    tab: ITeamTab;
    managedTags: Tag[];
    teamTags: Tag[];
    onManagedTagChange: (tag: Tag[]) => void;
    onTagsChange: (tag: Tag[]) => void;
    onChange?: (tab: ITeamTab) => void;
    changeColor?: (color: string) => void;
    changeTitlePosition?: (position: string) => void;
    titlePosition?: string;
    onSetLgLength?: (val: number) => void;
    onSetMobileEditor?: (val: boolean) => void;
    onSetMobTextLength?: (val: number) => void;
    onTitleHiddenClick?: (val: boolean) => void;
    team: ComputedTeam;
    isModer?: boolean;
    hasCover?: boolean;
    titleIsHidden?:boolean;
    color: {
        // brighter: string,
        // darker: string,
        userColor: string
    };
    isPreview?: boolean;
    longreadLength: number;
    mobileEditorAction?: string;
    additionalContent?: IAddProjectCoverContent;
    longreadReady: boolean | null;
    onAdditionalContentChange?: (data: any) => void;
    setLongreadReady: (val: any) => void;
    vtype: string;
    teamFilter?: ITeamFilterModel;
    onUpdate?: (val: number) => void
    onSetAnchors?: (val: any) => void;
}



export const TeamLgEdit: FC<TeamTabEditPropsT> = (props) => {
    const theme = useTheme();

    const { 
      team, 
      titleIsHidden,
      additionalContent,
      onTitleHiddenClick, 
      changeColor, 
      onSetLgLength, 
      longreadLength,
      color, 
      longreadReady, 
      managedTags, 
      teamTags, 
      onManagedTagChange, 
      setLongreadReady, 
      onTagsChange,
      onUpdate, 
      isModer, 
      vtype, 
      teamFilter,
      hasCover,
      onSetAnchors,
      changeTitlePosition,
      titlePosition,
      onAdditionalContentChange
    } = props;

    const [onToggleBilingual] = useToggleBilingual(team, onUpdate )

    const onLongreadIsReady = (val: any) => {
      setLongreadReady && setLongreadReady(val || true)
    }

    const onTitlePositionChange = (pos: string) => {
        changeTitlePosition?.(pos)
    }

    //@ts-ignore
    const coverContent: ICoverContent = useMemo(() => {
        return {
          firstAsCover: true,
          editorComponent:  <div></div>,
          setFirstCover: undefined,
          isPresentation: true,
          teamId: team?.teamId,
        //   onPresentationHeaderChange: (ev: any) => {
        //     onTitleChange(ev.target.value) 
        //   },
          onLongreadIsReady: onLongreadIsReady,
        }
      }, [team])

    const lgPortalRef = useMemo(() => (longreadReady && document.querySelector("#lg-presentation-portal")), [longreadReady]);

    const isBilingual = useMemo(() => (team?.isBilingual || false), [team])

      const PresentationBlockPortal = useMemo(() => {
        if (lgPortalRef) {
      
          return createPortal(
            <ThemeProvider theme={theme}>
              {// @ts-ignore
                <PresentationBlock 
                  currentColor={color?.userColor}
                  onColorChange={(color: string) => changeColor && changeColor(color)}
                  requiredTags={managedTags}
                  additionalContent={additionalContent}
                  projectTags={teamTags}
                  hasCover={hasCover}
                  onAdditionalContentChange={onAdditionalContentChange}
                  onSetRequiredTags={onManagedTagChange}
                  onSetProjectTags={onTagsChange}
                  vTYPE={vtype}
                  isModer={isModer}
                  titleIsHidden={titleIsHidden}
                  // toggleHideInfo={() => setInfoIsHidden(!infoIsHidden)}
                  toggleHideTitle={() => onTitleHiddenClick && onTitleHiddenClick(!titleIsHidden)}
                  isBilingual={isBilingual}
                  onToggleBilingual={onToggleBilingual}
                  onTitlePositionChange={onTitlePositionChange}
                  titlePosition={titlePosition}
                  isTeamProject
                />
              }
            </ThemeProvider>

           ,
           lgPortalRef as Element,
          );
        }
       
      }, [
        color, 
        managedTags,
        teamTags,
        hasCover,
        isModer,
        vtype,
        theme,
        isBilingual,
        lgPortalRef,
        additionalContent,
        onToggleBilingual,
        onLongreadIsReady,
        onAdditionalContentChange
      ])

      const handleSetLgLength = (val: number) => {
        onSetLgLength && onSetLgLength(val);
      } 

      const onToggleMobileEditor = (val: any) => props.onSetMobileEditor && props.onSetMobileEditor(val)

      const onSetMobTextBlockLength = (val: any) => props.onSetMobTextLength && props.onSetMobTextLength(val)
      
      const { theme: newTheme } = createThemeByColor(color?.userColor, theme);

    return (   
      <ThemeProvider theme={newTheme}>
        <ProjectEditPageGrid isTeamPage offsetBottom={40}>
            <CustomBgWrapper backgroundColor={color.userColor}>
            <GlobalColoring color={color.userColor} /*brighter={color.brighter} darker={color.darker}*/ />
            <LongReadBlock 
                hasSpecialSourcesBlocks={true}
                raw={team}
                longReadLength={longreadLength}
                additionalContent={additionalContent}
                setLongReadLength={handleSetLgLength}
                mobileEditorAction={props.mobileEditorAction}
                toggleMobileEditor={onToggleMobileEditor}
                titleNewPosition={titlePosition}
                onSetMobTextLength={onSetMobTextBlockLength}
                isTeamLg
                teamFilter={teamFilter}
                coverContent={{...coverContent}}
                onSetAnchors={onSetAnchors}
            />
            {PresentationBlockPortal}
            </CustomBgWrapper>
        </ProjectEditPageGrid>
      </ThemeProvider>
    );
};
import { LangObject } from "@brg/api/dist/api-core/utils/lang-utils";
import { FC, useCallback, useState, useMemo } from "react";
import { ITeamFilterModel } from "./TeamFilterEditView";
import { GlobalColoring, ProjectEditPageGrid} from "shared/pages/projectEdit/styles";
import { API, Endpoints, Tag } from "@brg/api";
import LongReadBlock from "shared/pages/projectEdit/LongReadBlock";
import { ComputedTeam } from 'shared/helpers/types/computed/ComputedTeam';
import { ICoverContent } from "shared/pages/exploreHseContextsNew/const/coverContent";
import { CustomBgWrapper } from "shared/components/CustomBgWrapper/CustomBgWrapper";
import { PresentationBlock } from "shared/pages/projectEdit/components/PresentatitonBlock/PresentatitonBlock";
import { createPortal } from "react-dom";
import { useHistory } from "react-router-dom";
import { CreateLinkTo } from "shared/constants/linkTo";
import { ThemeProvider, useTheme } from "styled-components";
import { createThemeByColor } from "shared/helpers/coloring";
import { useToasts } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { useToggleBilingual } from "shared/hooks/useToggleBilingual";
import { IAddProjectCoverContent } from "shared/pages/projectEdit/components/PresentatitonBlock/types/AdditionalContentType";

export const SET_BILINGUAL_FLAG = 'SET_BILINGUAL_FLAG';
export const REMOVE_BILINGUAL_FLAG = 'REMOVE_BILINGUAL_FLAG';

export interface ITeamTab {
    path: string;
    name: LangObject[];
    about: LangObject[];
    filter: ITeamFilterModel;
    isMain: boolean;
    gridTitle: LangObject[];
    gridTitleLink: LangObject[];
}

type TeamTabEditPropsT = {
    tab: ITeamTab;
    managedTags: Tag[];
    teamTags: Tag[];
    onManagedTagChange: (tag: Tag[]) => void;
    onTagsChange: (tag: Tag[]) => void;
    onChange?: (tab: ITeamTab) => void;
    changeColor?: (color: string) => void;
    changeTitlePosition?: (position: string) => void;
    titlePosition?: string;
    onSetLgLength?: (val: number) => void;
    onSetMobileEditor?: (val: boolean) => void;
    onSetMobTextLength?: (val: number) => void;
    onTitleHiddenClick?: (val: boolean) => void;
    team: ComputedTeam;
    isModer?: boolean;
    hasCover?: boolean;
    titleIsHidden?:boolean;
    color: {
        // brighter: string,
        // darker: string,
        userColor: string
    };
    isPreview?: boolean;
    longreadLength: number;
    mobileEditorAction?: string;
    additionalContent?: IAddProjectCoverContent;
    longreadReady: boolean | null;
    onAdditionalContentChange?: (data: any) => void;
    setLongreadReady: (val: any) => void;
    vtype: string;
    teamFilter?: ITeamFilterModel;
    onUpdate?: (val: number) => void
    onSetAnchors?: (val: any) => void;
}



export const TeamLgEdit: FC<TeamTabEditPropsT> = (props) => {
    const theme = useTheme();

    const { 
      team, 
      titleIsHidden,
      additionalContent,
      onTitleHiddenClick, 
      changeColor, 
      onSetLgLength, 
      longreadLength,
      color, 
      longreadReady, 
      managedTags, 
      teamTags, 
      onManagedTagChange, 
      setLongreadReady, 
      onTagsChange,
      onUpdate, 
      isModer, 
      vtype, 
      teamFilter,
      hasCover,
      onSetAnchors,
      changeTitlePosition,
      titlePosition,
      onAdditionalContentChange
    } = props;

    const [onToggleBilingual] = useToggleBilingual(team, onUpdate )

    const onLongreadIsReady = (val: any) => {
      setLongreadReady && setLongreadReady(val || true)
    }

    const onTitlePositionChange = (pos: string) => {
        changeTitlePosition?.(pos)
    }

    //@ts-ignore
    const coverContent: ICoverContent = useMemo(() => {
        return {
          firstAsCover: true,
          editorComponent:  <div></div>,
          setFirstCover: undefined,
          isPresentation: true,
          teamId: team?.teamId,
        //   onPresentationHeaderChange: (ev: any) => {
        //     onTitleChange(ev.target.value) 
        //   },
          onLongreadIsReady: onLongreadIsReady,
        }
      }, [team])

    const lgPortalRef = useMemo(() => (longreadReady && document.querySelector("#lg-presentation-portal")), [longreadReady]);

    const isBilingual = useMemo(() => (team?.isBilingual || false), [team])

      const PresentationBlockPortal = useMemo(() => {
        if (lgPortalRef) {
      
          return createPortal(
            <ThemeProvider theme={theme}>
              {// @ts-ignore
                <PresentationBlock 
                  currentColor={color?.userColor}
                  onColorChange={(color: string) => changeColor && changeColor(color)}
                  requiredTags={managedTags}
                  additionalContent={additionalContent}
                  projectTags={teamTags}
                  hasCover={hasCover}
                  onAdditionalContentChange={onAdditionalContentChange}
                  onSetRequiredTags={onManagedTagChange}
                  onSetProjectTags={onTagsChange}
                  vTYPE={vtype}
                  isModer={isModer}
                  titleIsHidden={titleIsHidden}
                  // toggleHideInfo={() => setInfoIsHidden(!infoIsHidden)}
                  toggleHideTitle={() => onTitleHiddenClick && onTitleHiddenClick(!titleIsHidden)}
                  isBilingual={isBilingual}
                  onToggleBilingual={onToggleBilingual}
                  onTitlePositionChange={onTitlePositionChange}
                  titlePosition={titlePosition}
                  isTeamProject
                />
              }
            </ThemeProvider>

           ,
           lgPortalRef as Element,
          );
        }
       
      }, [
        color, 
        managedTags,
        teamTags,
        hasCover,
        isModer,
        vtype,
        theme,
        isBilingual,
        lgPortalRef,
        additionalContent,
        onToggleBilingual,
        onLongreadIsReady,
        onAdditionalContentChange
      ])

      const handleSetLgLength = (val: number) => {
        onSetLgLength && onSetLgLength(val);
      } 

      const onToggleMobileEditor = (val: any) => props.onSetMobileEditor && props.onSetMobileEditor(val)

      const onSetMobTextBlockLength = (val: any) => props.onSetMobTextLength && props.onSetMobTextLength(val)
      
      const { theme: newTheme } = createThemeByColor(color?.userColor, theme);

    return (   
      <ThemeProvider theme={newTheme}>
        <ProjectEditPageGrid isTeamPage offsetBottom={40}>
            <CustomBgWrapper backgroundColor={color.userColor}>
            <GlobalColoring color={color.userColor} /*brighter={color.brighter} darker={color.darker}*/ />
            <LongReadBlock 
                hasSpecialSourcesBlocks={true}
                raw={team}
                longReadLength={longreadLength}
                additionalContent={additionalContent}
                setLongReadLength={handleSetLgLength}
                mobileEditorAction={props.mobileEditorAction}
                toggleMobileEditor={onToggleMobileEditor}
                titleNewPosition={titlePosition}
                onSetMobTextLength={onSetMobTextBlockLength}
                isTeamLg
                teamFilter={teamFilter}
                coverContent={{...coverContent}}
                onSetAnchors={onSetAnchors}
            />
            {PresentationBlockPortal}
            </CustomBgWrapper>
        </ProjectEditPageGrid>
      </ThemeProvider>
    );
};
